import styled, {css} from 'styled-components'

export const StyledAgeFilterRoot = styled.div`
    ${({theme: {spacing}}) => css`
        padding-top: ${spacing * 3}px;
    `}
`
